(function() {
  const SECTION_ID = 'availability-badges';
  const CONTAINER_ID = 'availability-badges-section';
  let lastVariantId = null;
  let updateTimer = null;

  function getVariantIdFromUrl() {
    return new URLSearchParams(window.location.search).get('variant');
  }

  async function updateBadges(variantId) {
    if (!variantId || variantId === lastVariantId) return;
    lastVariantId = variantId;

    try {
      const url = `${window.location.pathname}?variant=${variantId}&section_id=${SECTION_ID}`;
      const response = await fetch(url);
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.getElementById(CONTAINER_ID);
      const currentContent = document.getElementById(CONTAINER_ID);
      if (newContent && currentContent) {
        currentContent.replaceWith(newContent);
      }
    } catch (err) {
      console.error('Availability badge update failed:', err);
    }
  }

  function scheduleCheck() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(() => {
      const newId = getVariantIdFromUrl();
      if (newId) updateBadges(newId);
    }, 200);
  }

  // Initialize
  lastVariantId = getVariantIdFromUrl();

  // Catch most themes: changes inside the product form
  document.addEventListener('change', (e) => {
    if (e.target.closest('form[action*="/cart/add"]')) scheduleCheck();
  });

  // Dawn / Shopify reference theme event
  document.addEventListener('variant:change', scheduleCheck);

  // Catch pushState-driven URL updates
  const originalPushState = history.pushState;
  history.pushState = function() {
    originalPushState.apply(history, arguments);
    scheduleCheck();
  };
  window.addEventListener('popstate', scheduleCheck);
})();